import { createAsyncThunk } from '@reduxjs/toolkit';

import * as Sentry from '@sentry/browser';

import * as CouponService from 'Services/CouponService';

import { getIsAuthenticated } from 'dux/auth/selectors';

import { getIsLoading } from './selectors';

export const fetchCouponsStatuses = createAsyncThunk(
  'couponsStatuses/fetchCouponsStatuses',
  async () => {
    try {
      const data = await CouponService.getCouponsStatuses();
      return data;
    } catch (error) {
      Sentry.withScope(scope => {
        scope.setLevel('error');
        Sentry.captureMessage(`[Coupons statuses] ${error.toString()}`);
      });
      throw error;
    }
  },
  {
    condition(_, { getState }) {
      const state = getState();
      return getIsAuthenticated(state) && !getIsLoading(state);
    },
  }
);
